import React from 'react';

import ErrorBoundary from 'components/utility/ErrorBoundary/ErrorBoundary';

import { TableBlockWrapper } from '../../FAQActivityTracker.styles';
import Table from './Table/Table';

interface ITableBlockProps {
  isMobileView?: boolean;
  data?: any;
  isLoading?: boolean;
  showNoResults?: boolean;
  error?: any;
  searchInputValue: string;
  handleSearchInput: (evt: any) => void;
}

const TableBlock: React.FC<ITableBlockProps> = (props) => {
  const {
    isMobileView,
    data,
    isLoading,
    error,
    handleSearchInput,
    searchInputValue,
    showNoResults,
  } = props;
  return (
    <TableBlockWrapper>
      <ErrorBoundary error={error}>
        <Table
          isMobileView={isMobileView}
          data={data}
          isLoading={isLoading}
          showNoResults={showNoResults}
          searchInputValue={searchInputValue}
          handleSearchInput={handleSearchInput}
        />
      </ErrorBoundary>
    </TableBlockWrapper>
  );
};

export default TableBlock;
